<template>
  <b-row class="main-div titulo mb-50">
    <b-col cols="auto">
      <h4>
        {{ titulo }}
        <span :class="['status-badge', {'badge badge-danger':inativo, '': !inativo}]">
          {{ inativo ? 'Inativo' : '' }}
        </span>
        <span style="font-size: 14px;"><slot name="conteudo" /></span>
      </h4>
    </b-col>
    <b-col>
      <tag-cartao-proposta
        v-if="exibeTag"
        :value="tags"
        style="margin-top: 0.5rem;"
      />
    </b-col>
    <b-col
      v-if="showIcon"
      cols="auto"
      style="padding-right: 8px;padding-bottom: 1x;"
    >
      <slot name="edit" />

      <b-btn
        v-b-tooltip.hover
        variant="none"
        style="margin-top: -0.3rem;"
        class="btn-outline-danger btn-none rounded-pill icone-acao mr-50"
        title="Remover"
        @click="removerItem"
      >
        <feather-icon icon="TrashIcon" />
      </b-btn>
      <b-btn
        v-if="mostrarAdicionar"
        v-b-tooltip.hover
        title="Adicionar"
        variant="none"
        style="margin-top: -0.3rem;"
        class="btn-outline-info btn-none rounded-pill icone-acao mr-50"
        @click="adicionarItem"
      >
        <feather-icon icon="PlusIcon" />
      </b-btn>

      <div style="display: inline-flex;margin-top: -0.3rem;">
        <slot name="info" />
      </div>
    </b-col>
  </b-row>
</template>

<style>

.main-div {
  justify-content: space-between;
}

.titulo {
  padding-top: .6rem;
  border-bottom: 1px solid #0000006e;
  background-color: #f3f2edb8;
  border-radius: 4px;
}

.status-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.icone-acao {
  padding: 0.4rem;
}
</style>

<script>
export default {
  name: 'DivisoriaTitulo',
  components: {
    TagCartaoProposta: () => import('@/app-modulo/comercial/proposta/shared/components/tag-cartao-proposta/tag-cartao-proposta.vue'),
  },
  props: {
    titulo: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: () => true,
    },
    inativo: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    exibeTag: {
      type: Boolean,
      default: false,
    },
    mostrarAdicionar: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    adicionarItem() {
      this.$emit('apply')
    },
    removerItem() {
      this.$emit('remove')
    },
  },
}
</script>
